/**
 * Tag.
 *
 * @author Ryan Johnston <ryan.johnston@scalesology.com>
 */
import React, { Component } from 'react';

import childrenPropType from 'js/PropTypes/children';

/**
 * Tag Class
 */
class Tag extends Component {
    static propTypes = {
        children: childrenPropType,
    };

    static defaultProps = {
        children: null,
    };

    /**
     * Render the link.
     *
     * @returns {React.node}
     */
    render() {
        const { children } = this.props;

        return (
            <span className="tag">
                {children}
            </span>
        );
    }
}

export default Tag;
